var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#chevron-bottom-header';
                    var viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg#view-chevron-bottom-header';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?chevron-bottom-header#chevron-bottom-header';
                            viewUrl = 'svg/global.1d1faab74c5a9e7df7ed62ff2056061b.svg?chevron-bottom-header#view-chevron-bottom-header';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };